"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const avsc_1 = require("avsc");
const AvroError_1 = require("./AvroError");
class EventParser {
    /**
     * Parse a record value into a string that can be posted to REST Proxy.
     * @param {BaseAvroRecord} record
     */
    static parseValue(record) {
        const type = (0, avsc_1.parse)(record.schema(), {
            wrapUnions: true,
        });
        try {
            return type.clone(record, { wrapUnions: true });
        }
        catch (err) {
            if (err instanceof Error) {
                throw new AvroError_1.default(err.message);
            }
            throw err;
        }
    }
    static getSchema(record) {
        return JSON.stringify(record.schema());
    }
    static getTopic(record) {
        return EventParser.toKebabCase(record.schema().name);
    }
    static getInvalidTopic(record) {
        return "invalid-" + EventParser.getTopic(record);
    }
    static toKebabCase(str) {
        return str
            .split(/(?=[A-Z])/)
            .join("-")
            .toLowerCase();
    }
}
exports.default = EventParser;
//# sourceMappingURL=EventParser.js.map